import Storage from '@aws-amplify/storage';

import { FileField } from '../types';

const uploadFile = async (fileField: FileField, onProgress?: (val: number) => void) => {
  const { bucket, key, mimeType, localUri, region } = fileField;

  Storage.configure({ bucket, region });

  try {
    await Storage.put(key, localUri, {
      contentType: mimeType,
      customPrefix: {
        public: '',
      },
      progressCallback(progress: ProgressEvent) {
        const { loaded, total } = progress;
        onProgress && onProgress((loaded / total) * 100);
      },
    });
  } catch (error) {
    throw new Error(error);
  }
};

export default uploadFile;
